import baseEn from "commonAssets/i18n/en";

const confirmationPage = {
    ...baseEn.confirmation_page,
    title: "Your Election Form has been submitted successfully.",
    claim_details: {
        ...baseEn.confirmation_page.claim_details,
        title: "Your Election Details",
        body: "ELECTION INFORMATION",
        footer: '<p class="text-center fs-6">If you have any questions regarding your Election Form, please provide the Submitted Election ID listed above when contacting the Settlement Administrator.</p>',
    },
};

const confirmationScreenAdditional = {
    ...baseEn.confirmation_screen_additional,
    body: '<p class="fw-bold">You will receive a confirmation and copy of your election form via email, including your Submitted Election ID and Confirmation Code. Do not share your Election ID or Confirmation Code with others. We will never call you for this information.</p><p>You may also print this screen for your records.</p><p>If you don\'t receive a confirmation email after 3 days, please check your spam filter.</p>',
};

const contactUsSelectDropdown = {
    ...baseEn.contact_us_select_dropdown,
    claim_form: "Election Form",
};

const en = {
    ...baseEn,
    claim_edit_instructions:
        "Please update any election form fields and then click Submit at the bottom of this page to update your Election Form.",
    claim_edit_notice:
        'Filed an election form? <a href="javascript:void(0);" id="editClaimBtn">Click here</a> to edit your election form.',
    claim_edit_title: "Edit Election Form",
    claim_form_errors: "There are errors on the Election Form.",
    claim_submit_error:
        "There was an error submitting your election form, please try again.",
    claim_submit_success: "Thank you, your election form has been submitted.",
    confirmation_page: confirmationPage,
    confirmation_this_is_a_copy: "THIS IS A COPY OF YOUR ELECTION FORM",
    confirmation_screen_additional: confirmationScreenAdditional,
    contact_us_select_dropdown: contactUsSelectDropdown,
    deadline_claim: "The deadline to submit an Election Form has passed.",
    nav_submit_claim_button: "Submit Election Form",
    not_eligible_submit_claim:
        "You are not eligible to submit an election form.",
    otp_instructions_2:
        "Please enter the 6 digit code below to access your election form.",
    claim_id_if_known: "Election ID (if known)",
};

export default { en };
